import React from 'react';

/** components */
import LabelWithTooltip from './LabelWithTooltip';

const FormTextArea = ({
  data,
  field,
  dataError,
  handleChange,
  fieldClassName,
  toggleFieldModal,
  isModalOpen,
}) => {
  return (
    <>
      <div key={field.name} className={fieldClassName}>
        <div className="form-field">
          <LabelWithTooltip
            field={field}
            toggleFieldModal={toggleFieldModal}
            isModalOpen={isModalOpen}
          />
          <textarea
            id={field.name}
            value={data[field.name]}
            name={field.name}
            onChange={(e) => handleChange(e, field.name, field)}
            type={field.type}
            className={dataError[field.name] ? 'error' : ''}
            placeholder={field.placeholder}
          />
        </div>

        {dataError[field.name] && <p className="error-text">{dataError[field.name]}</p>}
      </div>
    </>
  );
};

export default FormTextArea;
